import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import {
  Box,
  BottomNavigation,
  BottomNavigationAction,
  Tooltip,
} from '@mui/material';
import {
  Chat,
  Person,
  EmojiEmotions,
  Face,
  AdminPanelSettings,
  Logout,
} from '@mui/icons-material';

import { checkAdminClaim } from '../../utils/adminUtils';

const NAV_ITEMS = [
  { label: 'Chat', icon: <Chat />, path: '/' },
  { label: 'Nick', icon: <Face />, path: '/nick' },
  { label: 'Stav', icon: <EmojiEmotions />, path: '/stav' },
  { label: 'Adam', icon: <Person />, path: '/adam' },
];

const NavBar = () => {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      if (currentUser) {
        const adminStatus = await checkAdminClaim(currentUser);
        setIsAdmin(adminStatus);
      } else {
        setIsAdmin(false);
      }
    });
    return unsubscribe;
  }, [auth]);

  const handleNavChange = (_, path) => {
    if (path === 'logout') {
      signOut(auth)
        .then(() => navigate('/signin'))
        .catch(console.error);
    } else {
      navigate(path);
    }
  };

  const currentPath = location.pathname;

  const allItems = [
    ...NAV_ITEMS,
    ...(isAdmin ? [{ label: 'Admin', icon: <AdminPanelSettings />, path: '/admin' }] : []),
  ];

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        // Safe area for devices with home indicator (iPhone X+)
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
      }}
    >
      <BottomNavigation
        value={currentPath}
        onChange={handleNavChange}
        showLabels
        sx={{
          height: { xs: 56, sm: 64 },
          minHeight: { xs: 56, sm: 64 },
          '& .MuiBottomNavigationAction-root': {
            minWidth: { xs: 48, sm: 80 },
            padding: { xs: '6px 4px', sm: '8px 12px' },
            '& .MuiBottomNavigationAction-label': {
              fontSize: { xs: '0.65rem', sm: '0.75rem' },
              marginTop: { xs: '2px', sm: '4px' },
            },
            '& .MuiSvgIcon-root': {
              fontSize: { xs: '1.25rem', sm: '1.5rem' },
            },
          },
        }}
      >
        {allItems.map((item) => (
          <BottomNavigationAction
            key={item.path}
            label={item.label}
            value={item.path}
            icon={item.icon}
          />
        ))}
        <Tooltip title="Sign out">
          <BottomNavigationAction
            label="Logout"
            value="logout"
            icon={<Logout />}
            sx={{
              '&:hover': {
                color: 'error.main',
              },
            }}
          />
        </Tooltip>
      </BottomNavigation>
    </Box>
  );
};

export default NavBar;
